import React from 'react'
import Icon from '../../../../../components/icon'

import {
  ButtonWrapper,
  DeleteButton,
  Button,
} from './styles'

type IProps = {
  remove: () => void;
  handleQRCode: () => void;
  hasDeleteButton: boolean;
}

const FormActions = ({ remove, handleQRCode, hasDeleteButton }: IProps) => (
  <ButtonWrapper>
    {
      hasDeleteButton ? (
        <DeleteButton
          type="button"
          onClick={remove}
        >
          <Icon name="trash" />
          Excluir mesa
        </DeleteButton>
      ) : (
        <Button
          type="button"
          onClick={handleQRCode}
        >
          <Icon name="qrcode" />
          Gerar QR Code
        </Button>
      )
    }
  </ButtonWrapper>
)

export default FormActions
